import { createAction } from '@reduxjs/toolkit';

export type FlagsmithFlag = string | number | boolean;

export interface FlagsmithFlags {
  [key: string]: FlagsmithFlag;
}

export interface FlagsmithState {
  flags: FlagsmithFlags;
  identity: string;
}

export const setFlagsmithProperties = createAction<FlagsmithFlags>('flagsmith/setFlagsmithProperties');
